let state = {
  dayinfo: [],
  home: 0,
  // 已预约课程
  course: [],
  // 约课页面选择的时段
  curTime: [],
  detailData: null,
  currDay: null,
  initAllShop: false // 请求完整数据 更新标志位
}

const mutations = {
  // 请求完整数据 更新标志位
  initAllShop(state, b) {
    state.initAllShop = b
  },
  // 设置跳转课程详情数据
  setDetailData(state, b) {
    state.detailData = b
  },
  // 设置跳转课程详情的当前日期
  setCurrDay(state, b) {
    state.currDay = b
  },
  // 设置约课列表 当前可选择的时间段列表
  setCurTime(state, arr) {
    state.curTime = arr
  },
  dayinfo(state, obj) {
    state.dayinfo = obj
  },
  homedata(state, obj) {
    state.home = obj
  },
  // 同步已预约课程
  course(state, obj) {
    if (obj && obj.detail) {
      //  二次修改
      state.course.push(obj)
      ChangeBtn(state, obj)
    } else {
      //  初次进入
      state.course = obj
    }
  },
  cancelCourse(state, obj) {
    //  二次修改
    state.course.map((v, i) => {
      if (v.memberappointmentid === obj.memberappointmentid)
        state.course.splice(i, 1)
    })
    ChangeCancelBtn(state, obj)
  }
}
function ChangeCancelBtn(state, obj) {
  //  取消预约后改状态-变亮按钮
  const day = obj.day || obj.info.slice(4, 14).trim()
  const shopname = obj.shopname || obj.detailshopname.trim()
  const name = obj.coachname || obj.info.slice(0, 4).trim()
  const courseid = obj.courseid || obj.detailcid
  for (let k in state.home) {
    if (k === day) {
      for (let i in state.home[k]) {
        if (state.home[k][i]['shop_name'] === shopname) {
          for (let j in state.home[k][i]) {
            let aaa = state.home[k][i][j]
            if (j !== 'shop_name' && state.home[k][i][j].name === name) {
              ++state.home[k][i][j].left
              for (let v in state.home[k][i][j]['day_data']) {
                if (state.home[k][i][j]['day_data'][v].courseid === courseid) {
                  if (state.home[k][i][j]['day_data'][v].left_course > 0)
                    state.home[k][i][j]['day_data'][v].left_course -= 1
                  console.log(
                    '取消预约成功-按钮',
                    state.home[k][i][j]['day_data'][v]
                  )
                  return
                }
              }
            }
          }
        }
      }
    }
  }
}
function ChangeBtn(state, obj) {
  //  预约后改状态-变灰按钮
  const day = obj.info.slice(4, 14).trim()
  const shopname = obj.detailshopname.trim()
  const name = obj.info.slice(0, 4).trim()
  const courseid = obj.detailcid
  for (let k in state.home) {
    if (k === day) {
      for (let i in state.home[k]) {
        if (state.home[k][i]['shop_name'] === shopname) {
          for (let j in state.home[k][i]) {
            let aaa = state.home[k][i][j]
            if (j !== 'shop_name' && state.home[k][i][j].name === name) {
              --state.home[k][i][j].left
              for (let v in state.home[k][i][j]['day_data']) {
                if (state.home[k][i][j]['day_data'][v].courseid === courseid) {
                  if (
                    state.home[k][i][j]['day_data'][v].coursenums >
                    state.home[k][i][j]['day_data'][v].left_course
                  )
                    state.home[k][i][j]['day_data'][v].left_course += 1
                  console.log(
                    '预约成功-按钮',
                    state.home[k][i][j]['day_data'][v]
                  )
                  return
                }
              }
            }
          }
        }
      }
    }
  }
}
const getters = {}

const actions = {}
export default {
  state,
  mutations,
  actions,
  getters
}
